module.exports = __webpack_public_path__ + "o-suitcase-green.516f0cd9c596ac5e327c.png";


//////////////////
// WEBPACK FOOTER
// E:/Github/trosten/trosten-web-app/src/assets/o-suitcase-green.png
// module id = ../../../../../src/assets/o-suitcase-green.png
// module chunks = main